var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2167AE",
    d: "M16 4a1 1 0 0 0-1-1H8.86a1 1 0 0 0-.36.07V6.5C8.5 7.33 7.83 8 7 8H4v10a1 1 0 0 0 1 1h5.34q.18.52.46 1H5a2 2 0 0 1-2-2V8.04c0-.52.2-1.01.55-1.38l3.86-4.04A2 2 0 0 1 8.86 2H15a2 2 0 0 1 2 2v7.08a6 6 0 0 0-1-.08zM4.6 7H7a.5.5 0 0 0 .5-.5V3.97zm4.9 1a.5.5 0 0 0 0 1H13a.5.5 0 0 0 0-1zM6 11c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1H6.5A.5.5 0 0 1 6 11m.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9.5 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0 1a5 5 0 1 0 0-10 5 5 0 0 0 0 10m2.86-6.14c.2.2.2.52 0 .72l-1.67 1.7c-.2.2-.5.2-.7 0a.5.5 0 0 1 0-.7l.83-.86h-2.15q-.64.02-.9.23c-.16.13-.27.31-.27.63 0 .3.1.44.23.52q.25.18.94.19a.5.5 0 1 1 0 1c-.53 0-1.07-.08-1.48-.35q-.69-.46-.69-1.36t.65-1.41c.41-.32.95-.45 1.52-.45h2.15l-.83-.86a.5.5 0 0 1 0-.71c.2-.2.5-.2.7 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentForward);
export default __webpack_public_path__ + "static/media/DocumentForward.da4128e0c5feb69235142aa5477455f4.svg";
export { ForwardRef as ReactComponent };